import { render, staticRenderFns } from "./WFIconSelector.vue?vue&type=template&id=5a242cae&scoped=true"
import script from "./WFIconSelector.vue?vue&type=script&lang=js"
export * from "./WFIconSelector.vue?vue&type=script&lang=js"
import style0 from "./WFIconSelector.vue?vue&type=style&index=0&id=5a242cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a242cae",
  null
  
)

export default component.exports